import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaCalculator, FaChartLine, FaBuilding, FaTimes } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Nav.css";
import logo from "../Assets/Images/BooksCompl.png";
import ContactForm from "../ContactForm/ContactFormModal.js";

const NavigationBar = () => {
  const [showDropdownServices, setShowDropdownServices] = useState(false);
  // const [showDropdownCompany, setShowDropdownCompany] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const servicesItems = [
    { label: "USA Company Formation", icon: FaCalculator, path: "/usa-company-formation" },
    { label: "Tax Return", icon: FaBuilding, path: "/tax-return" },
    { label: "Bookkeeping", icon: FaCalculator, path: "/bookkeeping" },
    { label: "CFO Advisory", icon: FaChartLine, path: "/cfo-advisory" },
    { label: "Zoho Advisory", icon: FaChartLine, path: "/zoho-advisory" },
  ];

  const handleGetStartedClick = (e) => {
    e.preventDefault();
    setShowContactForm(true);
  };

  const handleCloseContactForm = () => {
    setShowContactForm(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-2">
        <div className="container">
          <Link className="navbar-brand" to="/" onClick={closeMobileMenu}>
            <img 
              src={logo} 
              alt="Logo" 
              className="img-fluid d-none d-md-block" 
              style={{ width: "250px" }} 
            />
            <img 
              src={logo} 
              alt="Logo" 
              className="img-fluid d-md-none" 
              style={{ width: "200px" }} 
            />
          </Link>

          <button
            className="navbar-toggler ms-auto"
            type="button"
            onClick={toggleMobileMenu}
            aria-expanded={mobileMenuOpen}
            aria-label="Toggle navigation"
          >
            {mobileMenuOpen ? (
              <FaTimes className="navbar-toggler-icon-x" />
            ) : (
              <span className="navbar-toggler-icon"></span>
            )}
          </button>

          <div className={`collapse navbar-collapse ${mobileMenuOpen ? "show" : ""}`} id="navbarContent">
            <button
              className="mobile-close-btn d-lg-none"
              onClick={closeMobileMenu}
              aria-label="Close menu"
            >
              <FaTimes />
            </button>

            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link menu-link" to="/" onClick={closeMobileMenu}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  className="nav-link menu-link" 
                  to="/pricing" 
                  onClick={(e) => {
                    closeMobileMenu();
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  Pricing
                </Link>
              </li>

              {/* Services Dropdown */}
              <li
                className="nav-item dropdown"
                onMouseEnter={() => setShowDropdownServices(true)}
                onMouseLeave={() => setShowDropdownServices(false)}
                onClick={() => setShowDropdownServices(!showDropdownServices)}
              >
                <Link
                  className="nav-link dropdown-toggle menu-link"
                  to="#"
                  id="servicesDropdown"
                  role="button"
                  aria-expanded={showDropdownServices}
                >
                  Services
                </Link>
                <ul
                  className={`dropdown-menu ${showDropdownServices ? "show" : ""}`}
                  aria-labelledby="servicesDropdown"
                >
                  {servicesItems.map((item, index) => (
                    <li key={index} className="dropdown-item d-flex align-items-center">
                      <item.icon className="text-primary me-2" />
                      <Link className="text-dark text-decoration-none" to={item.path} onClick={closeMobileMenu}>
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>

              <li className="nav-item">
                <Link className="nav-link menu-link" to="/blog" onClick={closeMobileMenu}>
                  Blog
                </Link>
              </li>
              
              <li className="nav-item">
                <Link className="nav-link menu-link" to="/events/zoho-books-ahmedabad" onClick={closeMobileMenu}>
                  Events
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link menu-link" to="/help" onClick={closeMobileMenu}>
                  Help Center
                </Link>
              </li>
            </ul>

            <div className="d-flex ms-lg-3 mt-2 mt-lg-0">
              <button
                className="btn btn-warning-custom me-2"
                onClick={(e) => {
                  handleGetStartedClick(e);
                  closeMobileMenu();
                }}
              >
                Get in Touch
              </button>
              <button
                className="btn btn-primary-custom"
                onClick={() => {
                  window.location.href = `${process.env.REACT_APP_REDIRECT_URL}/login`;
                  closeMobileMenu();
                }}
              >
                Login
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Contact Form Modal */}
      {showContactForm && (
        <ContactForm onClose={handleCloseContactForm} />
      )}
    </>
  );
};
export default NavigationBar;